import { createChangeSignal } from "../../shared/state/changeSignal";

/**
 * "Memories changed here" (ADR-0031 D5): a memory was kept, confirmed or discarded, so the
 * Thread it was kept from reads its list again, also in the other pane, which is another
 * window of this origin (WA-10). The change signal carries it there; it carries no memory
 * data, only the signal.
 */
const memories = createChangeSignal("memories");

export function notifyMemoriesChanged(): void {
  memories.notify();
}

export const onMemoriesChanged = memories.subscribe;
